export enum Type {
  SLIDER_GROUP = 'SLIDER_GROUP',
  SLIDER = 'SLIDER',
  SELECTION = 'SELECTION',
  DYNAMIC_TEXT = 'DYNAMIC_TEXT',
  ORGANIZATION_UNIT_COOPERATION_SELECTION = 'ORGANIZATION_UNIT_COOPERATION_SELECTION',
  SLIDER_DROPDOWN = 'SLIDER_DROPDOWN',
  SLIDER_DROPDOWN_GROUP = 'SLIDER_DROPDOWN_GROUP',
  BOOLEAN_SELECTION = 'BOOLEAN_SELECTION',
}

// core adds the basic properties to all elements

export type Core<T> = {
  uuid: string
  type: T
}

// slider group used for grouping slider elements

export type SliderGroup = Core<Type.SLIDER_GROUP> & {
  sliders: Slider[]
}

// slider cluster is used to group the slider answers

export type SliderClusterItem = {
  answerCount: number
  percentage: number
}

export type SliderCluster = {
  range0To25: SliderClusterItem
  range26To50: SliderClusterItem
  range51To75: SliderClusterItem
  range76To100: SliderClusterItem
}

// slider used for average value of percentage questions

export type Slider = Core<Type.SLIDER> & {
  value: {
    average: number
    answers: number[]
  }
  cluster: SliderCluster
  optionCluster?: OptionCluster
}

// selection used counting the selected options

export type Option = {
  uuid: string
  answerCount: number
  percentage: number
}

export type Selection = Core<Type.SELECTION> & {
  options: Option[]
}

// dynamic text used for accumulation all the answers

export type DynamicTextAnswer = string

export type DynamicText = Core<Type.DYNAMIC_TEXT> & {
  textAnswers: DynamicTextAnswer[]
}

// organization unit cooperation selection used for selecting one or multipe organization unit's often used for cooperation

export type Unit = {
  uuid: string
  answerCount: number
  percentage: number
}

export type OrganizationUnitCooperationSelection = Core<Type.ORGANIZATION_UNIT_COOPERATION_SELECTION> & {
  units: Unit[]
}

// slider dropdown group used for grouping slider dropdown elements

export type SliderDropdownGroup = Core<Type.SLIDER_DROPDOWN_GROUP> & {
  sliderDropdowns: SliderDropdown[]
}

// option cluster is used to group the slider dropdown answers

export type OptionClusterItem = {
  answerCount: number
  percentage: number
}

export type OptionCluster = {
  [optionUUID: string]: OptionClusterItem
}

// slider dropdown used for average value of percentage questions and percentage of selected options

export type SliderDropdown = Core<Type.SLIDER_DROPDOWN> & {
  value: {
    average: number
    answers: number[]
  }
  sliderCluster: SliderCluster
  optionCluster: OptionCluster
}

// boolean selection used for counting the yes/no selections

export type BooleanSelection = Core<Type.BOOLEAN_SELECTION> & {
  yesAmount: number
  yesPercentage: number
  noAmount: number
  noPercentage: number
}

export type Element =
  | SliderGroup
  | Slider
  | Selection
  | DynamicText
  | OrganizationUnitCooperationSelection
  | SliderDropdown
  | SliderDropdownGroup
  | BooleanSelection
